<template>
  <BaseFrame>
    <div class="container flex justify-between">
      <MypageSidebar class="desktop:w-2/12 mobile:hidden" />

      <div class="desktop:w-9/12 mobile:w-full">
        <router-view />
      </div>
    </div>
  </BaseFrame>
</template>

<script lang="ts" setup>
import { onUnmounted, onMounted } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';
import { useUserData } from '@/lib/mypage/useMypage';
import { useMypageStore } from '@/stores/mypage';

import BaseFrame from '@/components/baseComponent/BaseFrame.vue';
import MypageSidebar from '@/components/ui/mypage/SideBar.vue';

const mypageStore = useMypageStore();
const { setupUserData } = useUserData();

const resetUserData = () => {
  mypageStore.resetClient();
  mypageStore.resetCenter();
  mypageStore.resetGroup();
  mypageStore.resetUnit();
  mypageStore.resetMarketing();
};

onMounted(() => {
  onBeforeRouteUpdate(async (to, from) => {
    await setupUserData();
  });
});
onUnmounted(() => resetUserData());
</script>

<style lang="scss">
@import '@/assets/style/screens/screen.scss';
</style>
